import { Shader } from 'three';

export function disable_vertex_color(shader: Shader) {
  shader.vertexShader = shader.vertexShader.replace('#include <color_vertex>', '');
  shader.fragmentShader = shader.fragmentShader.replace('#include <color_fragment>', '');
}
